import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, inject, input, output } from '@angular/core';

import { BrandConfigService } from '@mobi/oiv-viewer-utils-ng-jslib';
import { MOBI_UI_HEADER_LOGO, MobiUiHeaderComponent, MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { mobiIcon } from '@mobi/rwc-utils-icons-jslib';

export interface HeaderIcon {
    icon: mobiIcon;
    isDisabled: boolean;
    className?: string[];
}

@Component({
    selector: 'oiv-viewer-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [MobiUiIconComponent, MobiUiHeaderComponent, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
    private cdr = inject(ChangeDetectorRef);
    #brandConfigService = inject(BrandConfigService);

    iconClick = output<HeaderIcon>();
    logoClick = output<void>();
    isDisplayIcon = input<boolean>(false);

    readonly HEADER_LOGO = MOBI_UI_HEADER_LOGO;

    iconMenu: HeaderIcon = { icon: 'menu', isDisabled: false };
    iconTheX: HeaderIcon = { icon: 'the_x', isDisabled: true };

    /**
     * Dynamically select header logo based on brand
     */
    headerLogo = computed(() => {
        return this.#brandConfigService.isProtekta() ? MOBI_UI_HEADER_LOGO.PROTEKTA : MOBI_UI_HEADER_LOGO.MOBILIAR;
    });

    toggleIcons(icon: HeaderIcon) {
        if (icon.icon === 'menu') {
            this.enableCloseIcon();
        } else if (icon.icon === 'the_x') {
            this.enableMenuIcon();
        }
        this.iconClick.emit(icon);
    }

    navigateToHomePage() {
        this.logoClick.emit();
    }

    enableMenuIcon() {
        this.iconMenu = { ...this.iconMenu, isDisabled: false };
        this.iconTheX = { ...this.iconTheX, isDisabled: true };
        this.cdr.detectChanges();
    }

    enableCloseIcon() {
        this.iconMenu = { ...this.iconMenu, isDisabled: true };
        this.iconTheX = { ...this.iconTheX, isDisabled: false };
        this.cdr.detectChanges();
    }
}
